import { MinzeElement } from 'minze'

export interface LvcSettingsIcon {}

export class LvcSettingsIcon extends MinzeElement {
  html = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 7.25975C7.60815 6.94436 9.89837 6.78752 13.5209 6.88152M21 7.11946C19.969 7.05127 19.3872 6.98962 18.4686 6.94074M18.4686 6.94074C18.4686 8.21075 17.217 9.26305 15.8194 9.26305C14.4217 9.26305 13.5209 8.10921 13.5209 6.88152M18.4686 6.94074C18.4686 6.2932 18.206 5.59054 17.8059 5.14297M13.5209 6.88152C13.5209 5.48387 14.684 4.5 16.0132 4.5C16.6778 4.5 17.2843 4.80145 17.6605 5.23609M5.22016 16.7593C4.3015 16.7104 4.03103 16.6723 3 16.6041M5.22016 16.7593C5.22016 15.4893 6.47173 14.437 7.86938 14.437C9.26704 14.437 10.1678 15.5908 10.1678 16.8185M5.22016 16.7593C5.22016 17.4069 5.48276 18.1095 5.88281 18.5571M10.1678 16.8185C13.803 16.6041 16.3175 16.9593 21 16.7817M10.1678 16.8185C10.1678 18.2162 9.00476 19.2001 7.67553 19.2001C7.01092 19.2001 6.40446 18.8986 6.0282 18.464" stroke="#1E007D" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `

  css = () => `
    
  `
}
